import { StageLayer } from '@nolimitcity/slot-launcher/bin/StageLayer';
import { gsap } from 'gsap';
import { Beheaded } from '../../Beheaded';
import { BeheadedEngineManager } from '../../reels/BeheadedEngineManager';
import { SoulWildIndicator } from './SoulWildIndicator';
import { SpinePlayer } from '../../../core/displayobject/SpinePlayer';
import { BeheadedSymbol } from '../../reels/symbol/BeheadedSymbol';
import { Helper } from '../../../core/utils/Helper';
import { GameSetting } from '../../../core/setting/GameSetting';
import { SoundManager } from '../../config/sound/SoundManager';

export class SoulWildSouls extends PIXI.Container implements StageLayer {
    public SoulVictims: SpinePlayer[] = [];
    public _soulSpinePath: string = 'spine/soul.json';

    constructor() {
        super();
    }

    public soulsToAlpha(toAlpha: number, durr: number = 0.25): void {
        this.SoulVictims.forEach((soul) => {
            gsap.to(soul, { duration: durr, alpha: toAlpha });
        });
    }

    private flyingTL:gsap.core.Timeline;
    public suckSouls(swIndicator: SoulWildIndicator[]): gsap.core.Timeline {
        this.flyingTL = Helper.setTimeline(this.flyingTL, gsap.timeline({  }));

        let travelDuration: number = GameSetting.isFastSpin ? 0.3 : 0.5;
        const delayOffset: number = GameSetting.isFastSpin ? 0.075 : 0.125;

        let totalAmmMissing: number = 0;
        let totalAmmCollected: number = 0;

        swIndicator.forEach((ind) => {
            if (ind.isEnabled) totalAmmMissing += ind.soulsMissing;
            if (ind.isEnabled) totalAmmCollected += ind.soulsCollected;
        });

        // 4 ,6 ,8
        this.SoulVictims.forEach((soul, indx) => {
            const collectIndex = totalAmmCollected + indx;

            if (indx >= totalAmmMissing) return;

            const target: SoulWildIndicator = fetchRightIndx(collectIndex, swIndicator);
            const toPosition = Helper.copyLocalPosition(soul, target);

            this.flyingTL.to(
                soul,
                {
                    duration: travelDuration,
                    x: toPosition.x,
                    y: toPosition.y,
                    ease: 'Back.easeIn',
                    onStart: () => {
                        SoundManager.playSoulWoosh();
                    },
                },
                0
            );

            this.flyingTL.add(() => {
                target.updateBar(1);
                soul.play({ animation: 'consumed' });
                Beheaded.soundPlayer.playSound(`wildCollect${collectIndex + 1}`);
            }, travelDuration);

            travelDuration += delayOffset;
        });

        function fetchRightIndx(value: number, indi: SoulWildIndicator[]): SoulWildIndicator {
            if (value < 4) {
                return indi[0];
            } else if (value < 10) {
                return indi[1];
            } else return indi[2];
        }
        
        return this.flyingTL;
    }

    public leaveSouls(evaluatedArea: string[][], cutIndx: number[]) {
        const tl = gsap.timeline();
        if(this.isResetPlaying) this.resetTL.totalProgress(1);

        evaluatedArea.forEach((reel, reelIndex) => {
            cutIndx[reelIndex] !== -1 &&
                reel.forEach((sym, symIndex) => {
                    if (symIndex >= cutIndx[reelIndex] && sym.includes('H')) {
                        const symbol = BeheadedEngineManager.getReel(reelIndex).getSymbol(symIndex)!;
                        const soul = this.createSoul(symbol);
                        const durr: number = soul.fetchDuration('spawn') / (GameSetting.isFastSpin ? 2 : 1);
                        tl.add(soul.play({
                            animation: 'spawn',
                            showOnEnd: true,
                            duration: durr,
                            onComplete: () => soul.play({ animation: 'loop', loop: true }),
                        }),0);
                        this.SoulVictims.push(soul);
                    }
                });
        });
        return tl;
    }

    private createSoul(target: BeheadedSymbol): SpinePlayer {
        const soul = this.addChild(new SpinePlayer(this._soulSpinePath));
        soul.position = Helper.copyLocalPosition(soul, target);

        soul.name = `SOUL_${this.SoulVictims.length}`;

        return soul;
    }

    public get isResetPlaying():boolean{
        return this.resetTL && this.resetTL.isActive();
    }

    public cleanSouls():void{
        this.SoulVictims.forEach((s) => {
            s.stop(true);
            s.destroy({ children: true });
            this.removeChildren();
        });
        this.SoulVictims = [];
    }

    private resetTL:gsap.core.Timeline;
    public reset(): void {
        this.flyingTL = Helper.setTimeline(this.flyingTL);
        this.resetTL = Helper.setTimeline(this.resetTL, gsap.timeline());
        this.SoulVictims.forEach((soul, i) => {
            const ranY = 40 + Math.random() * 15;
            const ranX = 25 - Math.random() * 20;
            this.resetTL.to(soul, { y: '-=' + ranY, duration: 0.5, alpha: 0 }, 0);
            this.resetTL.to(soul, { x: '+=' + ranX, duration: 0.5, alpha: 0 }, 0);
        });
        this.resetTL.add(() => {
            this.cleanSouls();
        })
    }
}
